var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 42.1 42.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M16.9 30.4h17.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.9,
    cy: 15.8,
    r: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M14.7 29.5l-4-4c-1.2-1.2-1.2-3.1 0-4.3l16-16C27.9 4 29.8 4 31 5.2l4 4c1.2 1.2 1.2 3.1 0 4.3l-16 16c-1.2 1.2-3.2 1.2-4.3 0zM15.8 16l8.3 8.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M13.8 34.2l-1.3 2.7M9.9 30.4l-2.8-.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubber);
export default __webpack_public_path__ + "static/media/rubber.7c983977af213abd1658a818fb2197f9.svg";
export { ForwardRef as ReactComponent };